module.exports = __webpack_public_path__ + "img/GU.a42fc212.png";